var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ImpedimentContainer',{attrs:{"title":"TBI-Daño cerebral por Trauma"}},[_c('p',[_c('b',[_vm._v("El estudiante presenta:")])]),_c('TreeOptions',{attrs:{"is-disabled":_vm.isDisabled,"show-error":_vm.showErrors && !_vm.isValid},model:{value:(_vm.optionsTree),callback:function ($$v) {_vm.optionsTree=$$v},expression:"optionsTree"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }